import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { CfmAddonDetailComponent } from '../cfm-addon-detail/cfm-addon-detail.component';
import { BogoOfferPopupComponent } from '../bogo-offer-popup/bogo-offer-popup.component';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { AccountService } from 'src/app/services/account.service';
import { SubjectService } from 'src/app/services/subject.service';
import { VerificationComponent } from '../verification/verification.component';

@Component({
  selector: 'app-addon-card-uplift',
  templateUrl: './addon-card-uplift.component.html',
  styleUrls: ['./addon-card-uplift.component.scss']
})
export class AddonCardUpliftComponent implements OnInit {
	@Input('sku') sku: any;
	@Input('addonType') addonType: any;
	@Input('source') source: String;
	@Output() onSelectPass: EventEmitter<any> = new EventEmitter();
	ismobileScreen = false;
	isArabic: boolean = false;
	numberlogin= null;
	constructor(private UTS: UtilitiesService,
		private modalController: ModalController,
		private SKUDS: SkuDataService,
		private AS: AccountService,
		private SS: SubjectService
	) { }

	ngOnInit(): void {
		const w = document.documentElement.clientWidth || window.innerWidth;
		if (w < 992) {
			this.ismobileScreen = true;
		  } else {
			this.ismobileScreen = false;
		  }
		this.isArabic = this.UTS.getLocaleLanguage().toLocaleLowerCase() === 'ar';
	}

	openAddonDetailsCfmView(): void{
		let data =  {
			cmsUrl: !this.isArabic ? this.sku.learnMore: this.sku.learnMoreAr,
			sku: this.sku
		}
		this.openBottomSheet(CfmAddonDetailComponent,
			{ data },
			'eand-full-height-screen eand-full-screen' 
			);
	}

	async openBottomSheet(component, data:any, cssClass:any ='verification-modal modal-fullscreen ') {
		const modal = await this.modalController.create({
		component: component,
		showBackdrop: true,
		backdropDismiss: true,
		componentProps: { data: data },
		cssClass: cssClass,
		});
		modal.onDidDismiss().then((x: any) => {
			if(x?.data?.proceedNow){
				this.buyAddon(this.sku);
			}
		  })
		return await modal.present();
	}

	showBogoPopup(){
		this.openBottomSheet(BogoOfferPopupComponent, null, 'verification-modal eand-partail-height-screen-bottom-70-mobile');
	}
	subscribeAddon(){
		this.SKUDS.set(this.sku);
		//   this.SDS.setAddon(this.addon);
		this.SS.resetVerification.next(true)
		setTimeout(() => {
			let catID = '';
			if(localStorage.getItem('CAT')){
			catID = localStorage.getItem('CAT');
			}
			if(this.sku){
				this.SS.currentAccount.subscribe((r) => {
					if ((r && r?.mobileNumber) || (r && r?.accountNo)) {
					  this.SS.account.next(
						r?.mobileNumber ? r?.mobileNumber : r?.accountNo ? r?.accountNo : ''
					  );
					  // check here
					  const num : any = r.mobileNumber ? r.mobileNumber : r.accountNo ? r.accountNo : '';
					  this.numberlogin = num
					}});
					
					if(this.numberlogin && this.sku?.type == 'passAddonSku'){
						this.bogoAddons();
					}else{
						this.buyAddon(this.sku);
					}
			}else{
				this.buyAddon(this.sku);
			}
		}, 500);
  	}
	onClickPass(){
		this.onSelectPass.emit({sku: this.sku});
	}

	bogoAddons(){
		let link = '/addAddonsLoggedIn';
		let basketAddons = this.createBasketAddons();
		if(this.sku && this.sku?.type == 'passAddonSku'){
		 const buyAddonRequest = {
		   "accountNo":this.numberlogin,
		   "validate": basketAddons?.length == 1 || true,
		   "type": "ONE_TIME",
		   "quantity": 1,
		   "locale":this.UTS.getLocaleLanguage(),
		   "basketAddons": basketAddons,
		   "mode":'caramel',
		   'gamingAddon': false,
		   "addonId": this.sku.skuId
		 };
		 this.SKUDS.addAddons(buyAddonRequest, link).subscribe((response: any) => {
		   if(response && response?.bogoSkus && response?.bogoSkus?.length > 0){
			 sessionStorage.setItem("BOGOs", JSON.stringify(response?.bogoSkus));
			 this.openBottomSheet(BogoOfferPopupComponent, null, 'verification-modal eand-partail-height-screen-bottom-70-mobile');
		   }else{
			this.buyAddon(this.sku);
		   }
		 },(e) => {
			this.buyAddon(this.sku);
		 })
		 return;
		}
	  }
	  createBasketAddons(): any{
		let basketAddons = [];
		basketAddons.push({'addonId':this.sku?.skuId});
		return basketAddons;
	  }
	  buyAddon(sku: any){
		const userInfo: any = this.AS.getUInfo();
		this.SS.skuDetails.next(sku);
		this.openBottomSheet(VerificationComponent,{type:this.addonType});
	}

}
